import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { LiftBySpotTileComponent } from './lift-by-spot-tile.component';
import {MatLegacyTooltipModule as MatTooltipModule} from "@angular/material/legacy-tooltip";

@NgModule({
  imports: [CommonModule, FlexLayoutModule.withConfig({ useColumnBasisZero: false }), SharedModule, MatTooltipModule],
  declarations: [LiftBySpotTileComponent],
  exports: [LiftBySpotTileComponent]
})
export class LiftBySpotTileModule {}
